import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import pillImg1 from './images/what-makes1.png';
import pillImg2 from './images/what-makes2.png';
import pillImg3 from './images/what-makes3.png';

const useStyles = makeStyles((theme) => ({
    sectionWrapper: {
        width: '100%',
        backgroundColor: '#0f0f0f',
        padding: '60px 0 40px 0',
        marginBottom: '0px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: '#141414',
            padding: '36px 0 20px 0',
            marginBottom: '0px',
        }
    },
    section: {
        maxWidth: '1314px',
        width: '100%',
        margin: '0 auto',
        padding: '0 24px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '30px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse',
            gap: '40px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0 20px',
            gap: '30px',
        }
    },
    pillsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '30px',
        flex: 1,
        maxWidth: '642px',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            gap: '10px',
            maxWidth: '100%',
        }
    },
    pillWrapper: {
        flex: 1,
        maxWidth: '194px',
        height: '460px',
        borderRadius: '999px',
        overflow: 'hidden',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.5)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '115px',
            height: '290px',
        }
    },
    pillImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
        transition: 'transform 0.4s ease',
        '&:hover': {
            transform: 'scale(1.05)',
        }
    },
    textContent: {
        flex: 1,
        maxWidth: '580px',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            textAlign: 'center',
            alignItems: 'center',
        }
    },
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '52px',
        fontWeight: 400,
        lineHeight: '115%',
        color: '#ffffff',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
            lineHeight: '100%',
            marginBottom: '20px',
            textAlign: 'center',
            maxWidth: '300px',
        }
    },
    paragraph: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '18px',
        fontWeight: 200,
        color: '#FFFFFF',
        lineHeight: '27px',
        marginBottom: '18px',
        '&:last-child': {
            marginBottom: 0,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            lineHeight: '24px',
            marginBottom: '16px',
            textAlign: 'center',
            color: '#FFFFFF',
            width: '430px',
            maxWidth: '100%',
        }
    }
}));

export const AboutUsWhatMakesDifferentSection = () => {
    const classes = useStyles();

    return (
        <Box className={classes.sectionWrapper}>
            <Box className={classes.section}>
                <Box className={classes.pillsContainer}>
                    <Box className={classes.pillWrapper}>
                        <img
                            src={pillImg1}
                            alt="What Makes SugarCribs Different 1"
                            className={classes.pillImage}
                        />
                    </Box>
                    <Box className={classes.pillWrapper}>
                        <img
                            src={pillImg2}
                            alt="What Makes SugarCribs Different 2"
                            className={classes.pillImage}
                        />
                    </Box>
                    <Box className={classes.pillWrapper}>
                        <img
                            src={pillImg3}
                            alt="What Makes SugarCribs Different 3"
                            className={classes.pillImage}
                        />
                    </Box>
                </Box>

                <Box className={classes.textContent}>
                    <Typography className={classes.sectionTitle}>
                        What Makes SugarCribs Different
                    </Typography>

                    <Typography className={classes.paragraph}>
                        Unlike mainstream platforms designed for mass-market volume, SugarCribs is intentionally built around quality, trust, and exclusivity.
                    </Typography>

                    <Typography className={classes.paragraph}>
                        Our platform is designed to help creators stand out, not get lost in crowded feeds and to help members discover premium creators through a curated experience rather than algorithms.
                    </Typography>

                    <Typography className={classes.paragraph}>
                        By prioritizing meaningful connections over endless scrolling, SugarCribs creates a marketplace where creators have greater visibility and members enjoy more intentional interactions.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default AboutUsWhatMakesDifferentSection;
